<template>
  <section class="app-documents">
    <v-container>
      <services-list :data="services"></services-list>
          </v-container>
  </section>
</template>

<script>
import { services } from '@/models/service';
import ServicesList from '@/components/ServicesList';
import { serviceSpgc } from '@/models/spgc/menu-services';
export default {
  metaInfo: {
    title: 'Gás - Central de Serviços',
  },
  components: {
    ServicesList,
  },
  data: () => {
    return {
      services: [...serviceSpgc],
    };
  },
};
</script>
